import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { routes } from '@foxera/app.routes';
import { environment } from '@foxera/environments/enviroment';
import { provideKeycloakAngular } from '@foxera/config/keycloack.config';
import { customPreset } from '@foxera/custom-preset';
import { ErrorHandlingInterceptor } from '@foxera/shared/interceptors/error-handling.interceptor';
import { TenantIdInterceptor } from '@foxera/shared/interceptors/tenant-id.interceptor';
import { AllCommunityModule, ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { providePrimeNG } from 'primeng/config';

// Register AG Grid modules globally
ModuleRegistry.registerModules([ClientSideRowModelModule, AllCommunityModule]);

export const appConfig: ApplicationConfig = {
  providers: [
    // Core
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    // HTTP
    provideHttpClient(
      withInterceptors([
        includeBearerTokenInterceptor,
        TenantIdInterceptor,
        ErrorHandlingInterceptor,
      ])
    ),

    // Auth
    provideKeycloakAngular(),

    // Animations
    provideAnimations(),

    // PrimeNG Global Config
    providePrimeNG({
      theme: {
        preset: customPreset, // 👈 attaches your custom theme

        options: {
          darkModeSelector: 'none', // or false
        },
      },
      translation: {
        firstDayOfWeek: 1, // Monday as first day
      },
    }),

    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerImmediately',
    }),

  ],
};
